<template>
	<svg width="200" height="100" viewBox="0 0 200 100">
		<!-- Background -->
		<rect width="200" height="100" fill="white" />

		<!-- Green area (positive values) with 6px gap -->
		<path
			d="M 20 44 L 180 44 L 180 20 L 20 20 Z"
			fill="#8dc533"
			opacity="0.2"
		/>

		<!-- Grid lines -->
		<path d="M 20 80 L 180 80" stroke="#ccc" stroke-width="1" />
		<path d="M 20 20 L 20 80" stroke="#ccc" stroke-width="1" />

		<!-- Center line (divider between positive and negative) -->
		<path d="M 20 50 L 180 50" stroke="#333" stroke-width="2" fill="none" />
	</svg>
</template>
<script setup lang="ts"></script>
